import React, { useEffect, useState, useRef } from "react";
import ArenaLogo from "../../assets/images/ArenaLogoBrandNew.png";
import maacLogo from "../../assets/images/maac-logoBrand.png";
import LakmeLogo from "../../assets/images/LakmeLogoBrand.png";
import aptechLearningLogo from "../../assets/images/aptechLearningLogoBrand.png";
import individualTraining_Banner from "../../assets/images/individualTraining Bannner.png";
import AvgcImg from "../../assets/images/AvgcImg.jpg";
import BeautyImg from "../../assets/images/BeautyImg.png";
import ITImage from "../../assets/images/ITImage.jpg";
import virtualProductionNew from "../../assets/images/virtualProductionNew.jpg";
import styles from "../OurBussiness/IndividualBusiness.module.scss";
import classNames from "classnames";
import BreadCrumb from "../CommonComponents/BreadCrumb.tsx";
import arenaAnimationImg from "../../assets/images/arenaAnimationImg.jpg";
import aptechaviationImg from "../../assets/images/aptechaviationImg.jpg";
import aviationAcademyNewLogo from "../../assets/images/aviationAcademyNewLogo.png";
import virtualProductionLogoNew from "../../assets/images/virtualProductionLogoNew.png";
import { motion } from "framer-motion";

const IndividualBusiness: React.FC = () => {
  const breadcrumb = [
    { title: "Home", link: "/" },
    { title: "Our Businesses", link: "/our-businesses" },
    { title: "Domestic Retail", link: "" },
  ];

  return (
    <div className={styles.OverviewBusinessPage}>
      <BreadCrumb menu={breadcrumb} />
      <motion.div
        initial={{ opacity: 0, y: 100 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ease: "easeInOut" }}
      >
        <Banner />
      </motion.div>

      <IndividualTraining />
    </div>
  );
};

export default IndividualBusiness;

const Banner: React.FC = () => {
  const [isTablet, setIsTablet] = useState(window.innerWidth < 992);
  useEffect(() => {
    const handleResize = () => setIsTablet(window.innerWidth < 992);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div className="container">
      {!isTablet ? (
        <div className={`${styles.Banner} section mt-5`}>
          <div className="row">
            <div
              className={`${styles.box} col-lg-7 col-md-12 col-sm-12 col-xs-12`}
            >
              <p className="heading">Domestic Retail</p>
              <p className={`${styles.desc} para`}>
                Aptech's Domestic Retail division offers a diverse range of{" "}
                <strong>vocational courses</strong> across various high-demand
                sectors, empowering students with industry-relevant skills for{" "}
                <strong>successful careers</strong> and{" "}
                <strong>professional growth</strong>. By focusing on vocational
                jobs in demand, our programs and training methodologies ensure
                that learners are equipped with skills required to excel in
                today's competitive job market.
              </p>
              <p className={`${styles.desc} para`}>
                Our key training verticals include:{" "}
              </p>
            </div>
            <div
              className={`${styles.BusinessBannerTwoCont} col-lg-5 col-md-12 col-sm-12 col-xs-12 d-flex`}
            >
              <img
                src={individualTraining_Banner}
                alt=""
                className={classNames(styles.BusinessBannerTwo, "img-fluid")}
              />
            </div>
          </div>
        </div>
      ) : (
        <div className={`${styles.Banner} section mt-5`}>
          <div className="row">
            <div
              className={`${styles.box} col-lg-7 col-md-12 col-sm-12 col-xs-12`}
            >
              <p className="heading">Domestic Retail</p>
              <p className={`${styles.desc} para`}>
                Aptech's Domestic Retail division offers a diverse range of{" "}
                <strong>vocational courses</strong> across various high-demand
                sectors, empowering students with industry-relevant skills for{" "}
                <strong>successful careers</strong> and{" "}
                <strong>professional growth</strong>. By focusing on vocational
                jobs in demand, our programs and training methodologies ensure
                that learners are equipped with skills required to excel in
                today's competitive job market.
              </p>
              <p className={`${styles.desc} para`}>
                Our key training verticals include:{" "}
              </p>
            </div>
            <div
              className={`${styles.BusinessBannerTwoCont} col-lg-5 col-md-12 d-flex`}
            >
              <img
                src={individualTraining_Banner}
                alt="BusinessBannerOne"
                className={`${styles.BusinessBannerOne} img-fluid col-md-6`}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const IndividualTraining: React.FC = () => {
  interface DataItem {
    src: string;
    title: string;
    description: string;
    logo: string;
    websiteUrl: string;
  }
  const data: DataItem[] = [
   
    {
      src: arenaAnimationImg,
      title: "Arena Animation",
      description:
        "Established in 1996, this is a leading multimedia and animation training institute offering specialized training in animation, VFX, game design, broadcast, and multimedia to aspiring students as well as seasoned professionals. The programs at Arena Animation are carefully crafted to nurture creativity and technical proficiency in students, catering to the growing demands of the media and entertainment industry",
      logo: ArenaLogo,
      websiteUrl: "https://www.arena-multimedia.com/in/en/",
    },
    {
      src: AvgcImg,
      title: "Maya Academy of Advanced Creativity (MAAC)",
      description:
        "One of Aptech’s premier brand specializing in high-end Animation, VFX, Gaming, and Digital Design training. Established in 2001, MAAC has rapidly evolved into a leader in the media and entertainment education sector, offering a wide range of career-oriented courses. With a wide network of centres across India and world, MAAC has trained thousands of students, preparing them for successful careers in the media and entertainment industry.",
      logo: maacLogo,
      websiteUrl: "https://www.maacindia.com/",
    },
    {
      title: "Lakmé Academy Powered by Aptech",
      src: BeautyImg,
      description:
        "In partnership with Lakmé, we launched Lakmé Academy Powered by Aptech with the mission to provide comprehensive courses in cosmetology, makeup, hair styling, skin care, and personal grooming. Incorporating both theory and practical classes, these programs are designed to prepare students for glamorous careers in the fashion, beauty and wellness, and wellness industry.",
      logo: LakmeLogo,
      websiteUrl: "https://www.lakme-academy.com/",
    },
    {
      title: "Avalon Academy",
      src: aptechaviationImg,
      description:
        "A state-of-the-art aviation, hospitality, and luxury retail training academy delivering job-oriented courses in aviation, hospitality, travel & tourism, event management, and luxury retail. Our training programs equip students with the necessary skills to excel in booming industries. By emphasizing hands-on learning and real-world applications, we provide our students with ample career growth opportunities in their chosen fields.",
      logo: aviationAcademyNewLogo,
      websiteUrl: "https://www.aptechaviationacademy.com/",
    },
    {
      title: "Aptech Learning",
      src: ITImage,
      description:
        "A well-known and much sough-after IT training institute offering comprehensive IT courses, ranging from foundational programs to advanced certifications. The courses cover areas such as software development, hardware and networking, AI and ML, cybersecurity. These are designed to meet industry standards, ensuring students excel in their respective fields and can compete in the dynamic tech landscape.",
      logo: aptechLearningLogo,
      websiteUrl: "https://www.aptechlearning.com/",
    },
    {
      title: "The Virtual Production Academy",
      src: virtualProductionNew,
      description:
        "Backed up by Aptech’s 27 years of experience in media and entertainment training that’s aligned with the latest industry requirements, we launched India’s first virtual production unit, The Virtual Production Academy in Mumbai, India. The academy trains students in virtual production and in the new craft of film making, helping them prepare themselves as seasoned professionals ready to face the dynamic media industry.",
      logo: virtualProductionLogoNew,
      websiteUrl: "https://thevirtualproductionacademy.com/",
    },
  ];

  const sectionRefs = useRef<(HTMLElement | null)[]>([]);
  const [hasAnimated, setHasAnimated] = useState<boolean[]>(
    data.map(() => false)
  );
  useEffect(() => {
    const observers = sectionRefs.current.map((ref, index) => {
      if (!ref) return null;

      const observer = new IntersectionObserver(
        ([entry]) => {
          // Only animate if scrolling down and it hasn't animated before
          if (entry.isIntersecting && !hasAnimated[index]) {
            setHasAnimated((prev) => {
              const updated = [...prev];
              updated[index] = true;
              return updated;
            });
          }
        },
        { threshold: 0.2, rootMargin: "0px 0px -50px 0px" } // Ensures it's triggered when scrolling down
      );

      observer.observe(ref);
      return observer;
    });

    return () => {
      observers.forEach((observer) => observer?.disconnect());
    };
  }, [hasAnimated]);

  return (
    <div className="container">
      <div className={`${styles.IndividualTraining} section`}>
        <div className={styles.EBGData}>
          {data.map((item, index) => {
            return (
              <motion.div
                key={index}
                ref={(el) => (sectionRefs.current[index] = el)}
                initial={{ opacity: 0, y: 100 }}
                animate={hasAnimated[index] ? { opacity: 1, y: 0 } : {}}
                transition={{
                  duration: 1,
                  ease: "easeInOut",
                  delay: index * 0.2,
                }}
                className={`row g-0 justify-content-center ${styles.EbgCardRow}`}
              >
                <div className={`col-lg-2 col-md-12 ${styles.EBGImgDiv}`}>
                  <img
                    src={item.src}
                    alt="Aptech Logo"
                    className={`${styles.logoImage} img-fluid`}
                  />
                </div>
                <div className="col-lg-10 col-md-12">
                  <div
                    className={`d-flex flex-column justify-content-end align-items-start ${styles.EbgDataContent}`}
                  >
                    {item.logo && (
                      <img
                        src={item.logo}
                        alt="Aptech Logo"
                        className={`${styles.logo}`}
                      />
                    )}
                    <h6
                      className={`${styles.contentTitle} caps subHeading mb-2 `}
                    >
                      {item.title}
                    </h6>

                    <p
                      className={`${styles.contentDescription} para`}
                      dangerouslySetInnerHTML={{ __html: item.description }}
                    ></p>
                    <button
                      className={`secondary-btn para ${styles.buttonStyle}`}
                      onClick={() => {
                        window.open(item.websiteUrl, "_blank");
                      }}
                    >
                      Know More
                    </button>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
      <motion.div
        ref={(el) => (sectionRefs.current[data.length] = el)}
        initial={{ opacity: 0, y: 100 }}
        animate={hasAnimated[data.length] ? { opacity: 1, y: 0 } : {}}
        transition={{
          duration: 1,
          ease: "easeInOut",
          delay: data.length * 0.2,
        }}
        className={`row ${styles.paragraphBottom}`}
      >
        <div className="col-12">
          <p className="para">
            Through the Domestic Retail business, Aptech has{" "}
            <strong>trained millions of students</strong> worldwide, providing
            them with
            <strong> industry-relevant skills</strong> that are aligned with
            vocational jobs in demand. Our commitment to{" "}
            <strong>quality education</strong> and{" "}
            <strong>skill development </strong>
            ensures that our students are well-equipped to meet industry demands
            and excel in their <strong>careers</strong>.
          </p>
        </div>
      </motion.div>
    </div>
  );
};
